import { ReactElement } from 'react';
import { SettingOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from 'common/components/antd/Button/Button';
import HeaderLayoutCounterpartyName
  from 'common/components/HeaderLayoutCounterpartyName/HeaderLayoutCounterpartyName.component';
import {
  SContainer,
  SProperties,
  SLabel,
  SText,
  SValueSpacer,
  SProperty,
} from './Header.style';

export const HeaderComponent = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <SContainer>
      <div
        style={{
          display: 'flex',
        }}
      >
        <div>
          <Space size={16}>
            <HeaderLayoutCounterpartyName />
          </Space>
        </div>

        <SProperties>
          <SProperty
            style={{
              width: 185,
            }}
          >
            <SLabel>{t('accountManagement.header.reserveAcc')}</SLabel>
            <SValueSpacer>
              <SText>500 000</SText>
            </SValueSpacer>
          </SProperty>
          <SProperty
            style={{
              width: 189,
            }}
          >
            <SLabel>{t('accountManagement.header.emissionAcc')}</SLabel>
            <SValueSpacer>
              <SText>329 124</SText>
            </SValueSpacer>
          </SProperty>
          <SProperty
            style={{
              width: 185,
            }}
          >
            <SLabel>{t('accountManagement.header.processingAcc')}</SLabel>
            <SValueSpacer>
              <SText>329 124</SText>
            </SValueSpacer>
          </SProperty>
          <SProperty
            style={{
              width: 185,
            }}
          >
            <SLabel>{t('accountManagement.header.totalAmount')}</SLabel>
            <SValueSpacer>
              <SText>210 921</SText>
            </SValueSpacer>
          </SProperty>
        </SProperties>
      </div>

      <div>
        <Button icon={<SettingOutlined />} />
      </div>
    </SContainer>
  );
};
